import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const GalleryGrid = ({ images, category }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setSelectedImage(images?.[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const navigateLightbox = (direction) => {
    const newIndex = direction === 'next' 
      ? (lightboxIndex + 1) % images?.length 
      : (lightboxIndex - 1 + images?.length) % images?.length;
    setLightboxIndex(newIndex);
    setSelectedImage(images?.[newIndex]);
  };

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {images?.map((image, index) => (
          <div
            key={index}
            className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer bg-muted"
            onClick={() => openLightbox(index)}
          >
            <Image
              src={image?.url}
              alt={image?.alt}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="text-white text-sm font-medium">{image?.title}</p>
                {image?.description && (
                  <p className="text-white/80 text-xs mt-1">{image?.description}</p>
                )}
              </div>
            </div>
            <div className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <Icon name="Expand" size={16} color="var(--color-foreground)" />
            </div>
            {image?.badge && (
              <div className="absolute top-3 left-3 px-2 py-1 rounded-full bg-primary text-primary-foreground text-xs font-medium">
                {image?.badge}
              </div>
            )}
          </div>
        ))}
      </div>
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors z-10"
          >
            <Icon name="X" size={24} color="white" />
          </button>

          <button
            onClick={(e) => {
              e?.stopPropagation();
              navigateLightbox('prev');
            }}
            className="absolute left-4 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors z-10"
          >
            <Icon name="ChevronLeft" size={28} color="white" />
          </button>

          <button
            onClick={(e) => {
              e?.stopPropagation();
              navigateLightbox('next');
            }}
            className="absolute right-4 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors z-10"
          >
            <Icon name="ChevronRight" size={28} color="white" />
          </button>

          <div className="max-w-6xl max-h-[90vh] w-full" onClick={(e) => e?.stopPropagation()}>
            <div className="relative">
              <Image
                src={selectedImage?.url}
                alt={selectedImage?.alt}
                className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
              />
              <div className="mt-4 text-center">
                <h3 className="text-white text-xl font-semibold mb-2">{selectedImage?.title}</h3>
                {selectedImage?.description && (
                  <p className="text-white/80 text-sm">{selectedImage?.description}</p>
                )}
                <p className="text-white/60 text-xs mt-2">
                  {lightboxIndex + 1} / {images?.length}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GalleryGrid;